import { render } from "./CxMeasuredPointDetailsPanel.vue?vue&type=template&id=63fc4a89"
import script from "./CxMeasuredPointDetailsPanel.vue?vue&type=script&lang=js"
export * from "./CxMeasuredPointDetailsPanel.vue?vue&type=script&lang=js"

import "./CxMeasuredPointDetailsPanel.vue?vue&type=style&index=0&id=63fc4a89&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__